import request from "@/utils/request";

// 查询美育浸润信息
export const  listItem =(query) =>{
    return request({
        url: "/businessservice/item/list",
        method:"get",
        params: query
    })
}

// 查询美育浸润信息
export const  listItemByMuseum =(query) =>{
    return request({
        url: "/businessservice/item/listByMuseum",
        method:"get",
        params: query
    })
}